import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { SavedConfigurationsPageInitialData } from "./savedConfigurationsPageInitialData";

export const savedConfigurationsPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.savedConfigurations(),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<SavedConfigurationsPageInitialData>>("/page-data/saved-configs"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
